export default "__VITE_PUBLIC_ASSET__43418295__"